import React, { useEffect, useState } from "react";
import {
  Modal,
  Input,
  Select,
  Button,
  Form,
  notification,
  Radio,
  Row,
  Col,
  Card,
  DatePicker,
  Collapse ,
  InputNumber,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import {
  CONFIGURATION_CONVERTER,
  CONFIGURATION_MANUAL_USER,
} from "../../Common/Constants";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../Common/APIConstants";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { generatedISOFormatDateString } from "../../Utils/DateConverstion";

dayjs.extend(utc);
dayjs.extend(timezone);


// const ManualEntryPopupContent = ({  onClose,
//   isAdd, 
//   form,
//   selectedRow,
//   isUpdate,
//   refetch,
//   setRefetch }) => {
//   const [data, setData] = useState([]);
//   const { makeRequest } = useStoreUpdaterWithAPI();
//   const location = useLocation();

//   const handleClear = () => {
//     form.resetFields();
//   };

//   const handleNotification = (msg) => {
//     notification.open({ message: `${msg}` });
//   };
//   const formatCreatedOn = (data) => {
//     console.log(data)
//     return {
//       ...data,
//       // createdOn: dayjs(data.createdOn).format("YYYY-MM-DD HH:mm:ss"),
//       createdOn: dayjs(data.createdOn),
//     };
//   };
//  useEffect(() => {
//   console.log(selectedRow)
//   const formData = formatCreatedOn(selectedRow? selectedRow:{})
//   console.log(formData)
//   console.log(isUpdate)
//   console.log(isAdd)
//     if (isAdd && !selectedRow ) {
//       form.resetFields();
//     } 
//     if (isUpdate && selectedRow) {
//       form.setFieldsValue(formData);
//     } else {
//       form.resetFields();
//     }
//   }, [isAdd, isUpdate, selectedRow, form]);

//   const handleAddFormChange = (changedValues, allValues) => {
//     setData({
//       ...allValues,
//       createdOn: allValues.createdOn ? allValues.createdOn.toISOString() : null, // Format DateTime
//       // createdOn: allValues.createdOn ? allValues.createdOn.format("YYYY-MM-DD HH:mm:ss") : null, // Format DateTime
//     });
//     console.log(allValues);
//   };

//   const handleAddFormSubmit = async () => {
//     try {
//       const url = APIConstants.INSERT_ENERGY_SOURCE_MANUAL_ENTRY;
//       // console.log(url);
//       console.log(data);

//       const response = await makeRequest({
//         type: "POST",
//         url: url,
//         body: data,
//       });
//       console.log(response);
//       // const url = isUpdate ? APIConstants.UPDATE_CONFIG_METER : APIConstants.INSERT_ENERGY_SOURCE_MANUAL_ENTRY;
//       // const method = isUpdate ? 'POST' : 'POST';

//       // const response = await makeRequest({
//       //   type: method,
//       //   url: url,
//       //   body: apiData,
//       // });
      
//             console.log(response.message)
//       handleNotification(response.message);
//       handleClear();
//       onClose();
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const modeselect = useSelector((state) => state.darkMode);
//   const { isdarkMode } = modeselect;

//   return (
//     <Form
//       form={form}
//       onFinish={handleAddFormSubmit}
//       name="add-group-form"
//       className="font-bold w-[600px]"
//       layout="vertical"
//       onValuesChange={handleAddFormChange}
//     >
//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="IEXGDAM" name="iexgdam" rules={[{ required: true, message: "Please enter IEXGDAM" }]}>
//             <InputNumber  className="group-input w-full"  />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="IEXDAM And RTM" name="iexdamAndRTM" rules={[{ required: true, message: "Please enter IEXDAMAndRTM" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="Wind" name="wind" rules={[{ required: true, message: "Please enter Wind" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="Solar" name="solar" rules={[{ required: true, message: "Please enter Solar" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="Sand Unit One" name="sandUnitOne" rules={[{ required: true, message: "Please enter SandUnitOne" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="Sand Unit Two" name="sandUnitTwo" rules={[{ required: true, message: "Please enter SandUnitTwo" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="Investment" name="investment" rules={[{ required: true, message: "Please enter Investment" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="SKO Sand" name="skoSand" rules={[{ required: true, message: "Please enter SKOSand" }]}>
//             <InputNumber  className="group-input  w-full " />
//          </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="SKO Investment" name="skoInvestment" rules={[{ required: true, message: "Please enter SKOInvestment" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="HSD Sand" name="hsdSand" rules={[{ required: true, message: "Please enter HSDSand" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="HSD Investment" name="hsdInvestment" rules={[{ required: true, message: "Please enter HSDInvestment" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="LPG Sand" name="lpgSand" rules={[{ required: true, message: "Please enter LPGSand" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       {/* Created On as DateTime Picker */}
//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="Created On" name="createdOn" rules={[{ required: true, message: "Please select Created On date & time" }]}>
//             <DatePicker
//               className="w-full group-input "
//               format="YYYY-MM-DD HH:mm:ss"
//               showTime // Enables Time Picker
//             />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Form.Item className="flex justify-end">
//         <Button htmlType="submit" className="blue-btn mr-2">Save</Button>
//         <Button className="blue-btn" onClick={handleClear}>Clear</Button>
//       </Form.Item>
//     </Form>
//   );
// };
  

const ManualEntryPopupContent = ({ onClose, isAdd, form, selectedRow, isUpdate,refetch,setRefetch }) => {
  const [data, setData] = useState([]);
  const { makeRequest } = useStoreUpdaterWithAPI();
    const mode = useSelector((state) => state.darkMode);
  
    const { isdarkMode } = mode;
  
    const theme = isdarkMode
    console.log(theme)
    const [isPanel1Complete, setIsPanel1Complete] = useState(false);
    const [isPanel2Complete, setIsPanel2Complete] = useState(false);
    const [isPanel3Complete, setIsPanel3Complete] = useState(false);
    const [isPanel4Complete, setIsPanel4Complete] = useState(false);
    const [isPanel5Complete, setIsPanel5Complete] = useState(false);
    const [isPanel6Complete, setIsPanel6Complete] = useState(false);
    const [showMsg1,setShowMsg1]= useState(false)
    const [showMsg2,setShowMsg2]= useState(false)
    const [showMsg3,setShowMsg3]= useState(false)
    const [showMsg4,setShowMsg4]= useState(false)
    const [showMsg5,setShowMsg5]= useState(false)

  const handleClear = () => {
    form.resetFields();
    setShowMsg1(false)
    setShowMsg2(false)
    setShowMsg3(false)
    setShowMsg4(false)
    setShowMsg5(false)
    
  };

  const handleNotification = (msg) => {
    notification.open({ message: `${msg}` });
  };

  useEffect(() => {
    if (isAdd && !selectedRow) {
      form.resetFields();
    }
    if (isUpdate && selectedRow) {
      form.setFieldsValue(selectedRow);
    } else {
      form.resetFields();
    }
  }, [isAdd, isUpdate, selectedRow, form]);

  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    if (date) {
      // Ensure the date is treated as UTC from the beginning
      const formattedDate = dayjs.utc(date.format("YYYY-MM-DD  HH:mm:ss")) // Force UTC without shift
        // .startOf("day") // Ensure time is 00:00:00
        .toISOString(); // Convert to ISO format

      setSelectedDate(formattedDate);
      console.log("Formatted Date:", formattedDate);
      return formattedDate
    }
  };
  const handleAddFormChange = (changedValues, allValues) => {
    // console.log(allValues?.createdOn?.toISOString())
    // const date = new Date(allValues?.createdOn) 
    // console.log(generatedISOFormatDateString(new Date (allValues?.createdOn)))

    // console.log(dayjs(allValues.createdOn).format("YYYY-MM-DD HH:mm:ss"))
    setData({
      ...allValues,
      createdOn: allValues.createdOn ? handleDateChange(allValues.createdOn) : null,
      // createdOn: allValues.createdOn ? generatedISOFormatDateString(new Date (allValues.createdOn)) : null,
    });
  };

  const handleAddFormSubmit = async () => {
    console.log(data)
    try {
      const url = APIConstants.INSERT_ENERGY_SOURCE_MANUAL_ENTRY;
      const response = await makeRequest({
        type: "POST",
        url: url,
        body: data,
      });
      handleNotification(response.message);
      handleClear();
      onClose();
      setRefetch(!refetch)
    } catch (err) {
      console.error(err);
    }
  };
  const { Panel } = Collapse;

const [activeKey, setActiveKey] = useState(['1']); // First panel open by default

const handleCollapseChange = (key) => {
  setActiveKey(key ? [key] : []); // Ensures only one panel opens at a time
  if (key==2) {
    setShowMsg1(true)
}else if (key==3) {
  setShowMsg2(true)
}else if (key==4) {
  setShowMsg3(true)
}else if (key==5) {
  setShowMsg4(true)
}else if (key==6) {
  setShowMsg5(true)
}
};

const validatePanel = (panelFields, allValues) => {
  return panelFields.every(field => allValues[field] !== undefined && allValues[field] !== null && allValues[field] !== "");
};

const checkPanel1Completion = (_, allValues, setIsPanel1Complete) => {
  const panel1Fields = ["unit1Grid", "unit1IEXGDAM", "unit1IEXDAMAndRTM", "unit1Wind", "unit1Solar"];
  setIsPanel1Complete(validatePanel(panel1Fields, allValues));
  // setShowMsg1(true)
};

const checkPanel2Completion = (_, allValues, setIsPanel2Complete) => {
  const panel2Fields = ["unit2Grid", "unit2IEXGDAM", "unit2IEXDAMAndRTM", "unit2Wind", "unit2Solar"];
  setIsPanel2Complete(validatePanel(panel2Fields, allValues));
  // setShowMsg1(true)
};

const checkPanel3Completion = (_, allValues, setIsPanel3Complete) => {
  const panel3Fields = ["unit1Production", "unit1Rejection", "unit2Production", "unit2Rejection", "investmentProduction", "investmentRejection"];
  setIsPanel3Complete(validatePanel(panel3Fields, allValues));
  // setShowMsg2(true)
};
const checkPanel4Completion = (_, allValues, setIsPanel3Complete) => {
  const panel4Fields = ["sandUnitHSD", "sandUnitSKO", "sandUnitLPG", "investmentHSD", "investmentSKO"];
  setIsPanel4Complete(validatePanel(panel4Fields, allValues));
  // setShowMsg3(true)
};
const checkPanel5Completion = (_, allValues, setIsPanel3Complete) => {
  const panel5Fields = ["createdOn"];
  setIsPanel5Complete(validatePanel(panel5Fields, allValues));
  // setShowMsg4(true)
};
// const checkPanel6Completion = (_, allValues, setIsPanel3Complete) => {
//   const panel6Fields = ["createdOn"];
//   setIsPanel6Complete(validatePanel(panel6Fields, allValues));
//   // setShowMsg5(true)
// };
const color = useSelector((state) => state.ThemeChange);
console.log(color)
useEffect(() => {
  document.documentElement.style.setProperty("--date-ok-btn", color.themeConfig.colorPrimary);
  document.documentElement.style.setProperty("--date-now-btn", "#fff");
}, [color]);

  return (

 <Form
    form={form}
    onFinish={handleAddFormSubmit}
    name="add-group-form"
    className="font-bold w-[100%]"
    layout="vertical"
    onValuesChange={(_, allValues) => {
      checkPanel1Completion(_, allValues, setIsPanel1Complete);
      checkPanel2Completion(_, allValues, setIsPanel2Complete);
      checkPanel3Completion(_, allValues, setIsPanel3Complete);
      checkPanel4Completion(_, allValues, setIsPanel4Complete);
      checkPanel5Completion(_, allValues, setIsPanel5Complete);
      // checkPanel6Completion(_, allValues, setIsPanel6Complete);
      handleAddFormChange(_, allValues);
    }}
  >
    <Collapse 
      activeKey={activeKey} 
      onChange={handleCollapseChange} 
      accordion 
      className={` ${ isdarkMode ? "dark-modal-collapse":''} h-[60vh] overflow-auto `}
    >
      <Panel  key="1" 
      header={
        <div className="flex items-center">
          Energy Data Entry (Daily) - Unit-1 (HTSC 99)
          {
            showMsg1&&<>
          {isPanel1Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      }>
        <Row gutter={8} className="">
          <Col span={6}><Form.Item label="Grid" name="unit1Grid" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="IEX GDAM" name="unit1IEXGDAM" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="IEX - DAM & RTM" name="unit1IEXDAMAndRTM" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="Wind" name="unit1Wind" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
        </Row>
        <Row gutter={8}>
          <Col span={6}><Form.Item label="Solar" name="unit1Solar" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
        </Row>
      </Panel>

      <Panel key="2" header={
        <div className="flex items-center">
          Energy Data Entry (Daily) - Unit-2 (HTSC 67)
          {
            showMsg2&&<>
          {isPanel2Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      }>
        <Row gutter={8} className="">
          <Col span={6}><Form.Item label="Grid" name="unit2Grid" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="IEX GDAM" name="unit2IEXGDAM" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="IEX - DAM & RTM" name="unit2IEXDAMAndRTM" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="Wind" name="unit2Wind" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
        </Row>
        <Row gutter={8}>
          <Col span={6}><Form.Item label="Solar" name="unit2Solar" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
        </Row>
      </Panel>

      <Panel  key="3" 
      header={
        <div className="flex items-center">
          Production Data Entry (Daily)
          {
            showMsg3&&<>
          {isPanel3Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      }>
        <Row gutter={8} className="">
          <Col span={6}><Form.Item label="Unit-1 Production" name="unit1Production" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="Unit-1 Rejection" name="unit1Rejection" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="Unit-2 Production" name="unit2Production" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="Unit-2 Rejection" name="unit2Rejection" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
        </Row>
        <Row gutter={8}>
          <Col span={6}><Form.Item label="Investment Production" name="investmentProduction" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="Investment Rejection" name="investmentRejection" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
        </Row>
      </Panel>

      <Panel  key="4"
      header={
        <div className="flex items-center">
          Resource Usage
          {
            showMsg4&&<>
          {isPanel4Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      }>
        <Row gutter={8} className="">
          <Col span={6}><Form.Item label="Sand Unit - HSD (L)" name="sandUnitHSD" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="Sand Unit - SKO (L)" name="sandUnitSKO" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="Sand Unit - LPG (kg)" name="sandUnitLPG" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
          <Col span={6}><Form.Item label="Investment - HSD (L)" name="investmentHSD" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
        </Row>
        <Row gutter={8}>
          <Col span={6}><Form.Item label="Investment - SKO (L)" name="investmentSKO" rules={[{ required: true }]}><InputNumber  className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`} /></Form.Item></Col>
        </Row>
      </Panel> 
      <Panel  key="5" header={
        <div className="flex items-center">
          Created On
          {
            showMsg5&&<>
          {isPanel5Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      }>
        <Row gutter={16}>
          <Col span={6}><Form.Item label="Created On" name="createdOn" rules={[{ required: true }]}><DatePicker  className={`  ${isdarkMode ? "datebackground dateplaceholder" : "whitemode"} w-80 `}
              dropdownClassName={isdarkMode ? "datedropdown" : "whitemode"} format="YYYY-MM-DD HH:mm:ss" showTime 
              popupClassName="custom-picker"
              // onChange={handleDateChange}
               />
               </Form.Item></Col>
        </Row>
      </Panel>
    </Collapse>

    <Form.Item className="flex justify-end mt-5">
      <Button htmlType="submit" className=" mr-2">Save</Button>
      <Button className="" type='primary' onClick={handleClear}>Clear</Button>
    </Form.Item>
    <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
           .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
  </Form>
  );
};

const ManualEntryPopup = ({ 
  isAdd,
  setIsAdd,  
  isUpdate, 
  selectedRow,
  setIsUpdate,
  title,
  refetch,
  setRefetch
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  // console.log(updateRecord);
  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_MANUAL_USER}/manual-entry-add-popup`) {
      setIsAdd(true);

      form.resetFields();
    } else {
      setIsAdd(false);
    }
  }, [location.pathname, form]);

  const handleClose = () => {
    setIsAdd(false);

    navigate(`${CONFIGURATION_MANUAL_USER}`);
    form.resetFields();
  };

  return (
    <>
      <PopupUI
        popupContent={
          <ManualEntryPopupContent
          onClose={handleClose}
          isAdd={isAdd}
          isUpdate={isUpdate}
          selectedRow={selectedRow} 
          form={form}
          title={title}
          refetch={refetch}
          setRefetch={setRefetch}
          />
        }
        isAdd={isAdd}
        setIsUpdate={setIsUpdate}
        handleClose={handleClose}
        isOpen={isAdd || isUpdate}
        title={title}
      />
    </>
  );
};

export default ManualEntryPopup;
